<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
  </div>
</template>
<script>
// import request from '@/utils/request'
import { Button } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '交易详情',
      backurl: '/store/index',
      moneyLogId: undefined
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.id = this.$route.params.id
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate
  }
}
</script>
